import {Component, Input, OnInit} from '@angular/core';
import {NgClass, NgForOf, NgSwitchCase} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {PermissionService} from "../../../../core/services/permission.service";
import {GeneralService} from "../../../../core/services/general.service";
import {AuthService} from "../../../../core/services/auth.service";

@Component({
  selector: 'app-password',
  standalone: true,
    imports: [
        NgForOf,
        ReactiveFormsModule,
        FormsModule,
        NgSwitchCase,
        NgClass
    ],
  templateUrl: './password.component.html',
  styleUrl: './password.component.scss'
})
export class PasswordComponent implements OnInit{
    @Input() confirmAction!: (data: any) => void;
    @Input() data: any;
    showPass: boolean = false;
    newPass: string = "";

    constructor(public modalService :NgbModal, private service: AuthService, private generalService: GeneralService){
    }

    ngOnInit(): void {
    }

    // Función para alternar la visibilidad de la contraseña
    togglePasswordVisibility(field: boolean) {
        this.showPass = !field;
    }

    // Función para guardar las selecciones (puedes enviarlo al backend o hacer lo que necesites)
    saveSelection() {
        this.service.changePass({id: this.data['users.id'], p: this.newPass}).subscribe(
            (res: any) => {
                if (res.error) {
                    this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
                } else {
                    this.generalService.showMessage('success', res.message);
                    this.modalService.dismissAll();
                    //this.modules = this.buildModuleTree(res.message);
                    //console.log(this.modules);
                }
            },
            (err) => {
                this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
            }
        );
    }
}
